import { Button } from "@/components/common/Button/Button"
import { SharepointIcon } from "@/components/common/icons/SharepointIcon/SharepointIcon"
import { Typography } from "@/components/common/Typography/Typography"
import { Button as ShadcnButton } from "@/components/ui/button"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { IconLoader2 } from "@tabler/icons-react"

interface SharepointConnectButtonProps {
  onConnect: () => void
  loading: boolean
  error?: string | null
  compact?: boolean
}

export const SharepointConnectButton: React.FC<
  SharepointConnectButtonProps
> = ({ onConnect, loading, error, compact = false }) => {
  const { translate } = useTranslation()

  if (compact) {
    return (
      <ShadcnButton
        variant="outline"
        size="sm"
        className="h-8 gap-1.5 px-3"
        onClick={onConnect}
        disabled={loading}
      >
        {loading ? (
          <IconLoader2 size={14} className="animate-spin" />
        ) : (
          <SharepointIcon size={14} />
        )}
        <span className="text-xs">
          {loading
            ? translate("SHAREPOINT/CONNECTING")
            : translate("SHAREPOINT/CONNECT_BUTTON")}
        </span>
      </ShadcnButton>
    )
  }

  return (
    <div className="flex flex-col items-center gap-3">
      <Typography variant="textXS" as="p" className="text-grey4">
        {translate("SHAREPOINT/OR")}
      </Typography>
      {error && (
        <Typography variant="textXS" as="p" className="text-red1">
          {error}
        </Typography>
      )}
      <Button
        label={
          loading
            ? translate("SHAREPOINT/CONNECTING")
            : translate("SHAREPOINT/CONNECT_BUTTON")
        }
        title={
          loading
            ? translate("SHAREPOINT/CONNECTING")
            : translate("SHAREPOINT/CONNECT_BUTTON")
        }
        onClick={onConnect}
        variantColor="yellow"
        variantSize="medium"
        isFullWidth
        isDisabled={loading}
        IconLeft={loading ? IconLoader2 : SharepointIcon}
      />
    </div>
  )
}
